module.exports = __webpack_public_path__ + "static/bornagain-b744419d6645d3843a932cada2f966fb.jpg";